<template>
  <label class="sleep-radio d-block">
    <input
      name="set"
      :value="this.item?.ID"
      class="sleep-radio__input"
      type="radio"
      :checked="this.item?.ID === this.store.selected.variant"
      @change="setVariant($event)"
    />
    <span class="sleep-radio__wrapper d-block">
      <span class="grid-row grid-row_empty">
        <span class="grid-col grid-col_same d-block">
          <Icon :icon-path="this.store.bundle[this.getItem(1)]['ICON_PATH']" />
          <span class="sleep-radio__name d-block">
            {{ this.store.bundle[this.getItem(1)]["NAME"] }}
          </span>
        </span>

        <span class="grid-col d-block">
          <span class="sleep-radio__plus d-block"> + </span>
        </span>

        <span class="grid-col grid-col_same d-block">
          <Icon :icon-path="this.store.bundle[this.getItem(2)]['ICON_PATH']" />
          <span class="sleep-radio__name d-block">
            {{ this.store.bundle[this.getItem(2)]["NAME"] }}
          </span>
        </span>

        <span class="grid-col d-block">
          <span class="sleep-radio__plus d-block"> + </span>
        </span>

        <span class="grid-col grid-col_same d-block">
          <Icon :icon-path="this.store.bundle[this.getItem(3)]['ICON_PATH']" />
          <span class="sleep-radio__name d-block">
            {{ this.store.bundle[this.getItem(3)]["NAME"] }}
          </span>
        </span>
      </span>
    </span>
  </label>
</template>

<script>
import Icon from "./Icon.vue";
import { useBundleStore } from "@/sleep_bundle/stores/bundle";

export default {
  name: "BundleTypeItem",
  components: { Icon },
  props: {
    item: Object,
  },
  setup() {
    const store = useBundleStore();

    return {
      store,
    };
  },
  methods: {
    getItem(number) {
      return Number(this.item["POOL" + number]);
    },
    setVariant(e) {
      this.store.setVariant(e.target.value);
      this.store.clearSelectedOffers();
      this.store.clearFilters();
    },
  },
};
</script>
